
import sitecfg from '@/sitecfg.js'

const app = {
  state: {
    mark_homepage_play_now: false,
    
    // app loading 状态
    is_app_loading: '',

    // light dark
    theme: 'dark', 

    // lang
    mark_st_lang_changed: 0,
    lang: sitecfg.default_lang || "en",
    // is_tronlink_installed: window.tronWeb ? true : false,

    // data
    data_my_lion: [],
    
    // log last_path from my_collection
    last_path: '',
  },
  mutations: {
    lang(state, str) {
      state.mark_st_lang_changed = (new Date()).valueOf()
      window.localStorage.setItem('lang',str)
      state.lang = str;
    },
    
    theme(state, str) {
      window.localStorage.setItem('theme',str)
      state.theme = str;
    },
    setAppKey(state, obj) {
      for (let key in obj) {
        state[key] = obj[key];
      }
    },
  },
}

export default app